import { localeSetActions, localeGetActions } from "./index.js";
//import productActions from "Actions/productActions";
import geoIp from "Services/http/geoIp";
import featureFlags from "Services/http/featureFlags";
import Countries from "Services/http/countries";
import MarketsSvc from "Services/markets/marketsSvc";
import appActions from "Actions/appActions";
//NOTE: init actions run once on app load and never run again
//init actions can dispatch set, get, or additional init actions
const localeInitActions = (function() {
  const actions = {
    initGeoData: () => {
      return (dispatch, getState) => {
        dispatch(appActions.setIsLoading(true));
        geoIp.get().then(locale => {
          const preLoadedCountry = getState().locale.country;
          if(preLoadedCountry) {
            locale.country = preLoadedCountry;
          }
          const appMarkets = MarketsSvc.getMarketDefinitions();
          const defaultGeoMarket = appMarkets.filter(am => {
            return am.countryCode.toLowerCase() === locale.country.toLowerCase();
          });
          if(defaultGeoMarket.length) {
            (locale.country) && dispatch(localeSetActions.setCountry(locale.country));
          } else {
            let defaultMarket = appMarkets.filter(am => {
              return am.countryCode.toLowerCase() === 'us';
            });
            if(defaultMarket.length) {
              dispatch(localeSetActions.setCountry('US'));
            } else {
              dispatch(localeSetActions.setCountry(appMarkets[0].countryCode));
            }
          }
          dispatch(actions.initFeatureFlags());
          // dispatch(actions.initCountries());
        }).fail(()=>{
          console.log("geo ip failed")
          dispatch(localeSetActions.setCountry('US'));
          dispatch(actions.initFeatureFlags());
          dispatch(actions.initCountries());
        }).finally(()=>{
          dispatch(appActions.setIsLoading(false))
        });
      };
    },
    initCountries: () => {
      return dispatch => {
        Countries.get().done(res => {
          dispatch(localeSetActions.setCountries(res));
          dispatch(actions.initMarkets());
        });
      };
    },
    initMarkets: () => {
      return (dispatch, getState) => {
        let { apiCountryData: countries } = getState().locale;
        let markets = MarketsSvc.enrichMarketDefinitions(countries);
        //dispatch(localeGetActions.getCountryRegions());
        dispatch(localeSetActions.setMarkets(markets));
        dispatch(localeGetActions.getMarketCurrency());
        dispatch(localeGetActions.getLangOptions());
        dispatch(actions.initLocaleData());
      };
    },
    initLocaleData: () => {
      return dispatch => {
        dispatch(localeGetActions.getDefaultLanguage());
        dispatch(localeGetActions.getLocale());
        //dispatch(productActions.initProductData());
        //dispatch(localeGetActions.getShippingMethods());
        dispatch(localeSetActions.setPreLoaded(true));
      };
    },
    initFeatureFlags: () => {
      return dispatch => {
        featureFlags.get().then(featureFlags => {
          dispatch(localeSetActions.setFeatureFlags(featureFlags));
          dispatch(appActions.setIsLoading(false));
        });
      };
    }
  };
  return actions;
})();

export default localeInitActions;



// WEBPACK FOOTER //
// ./src/store/actions/localeActions/localeInitActions.js